import { render, staticRenderFns } from "./Gauge.global.vue?vue&type=template&id=4c708268&scoped=true&lang=pug&"
import script from "./Gauge.global.vue?vue&type=script&lang=ts&"
export * from "./Gauge.global.vue?vue&type=script&lang=ts&"
import style0 from "./Gauge.global.vue?vue&type=style&index=0&id=4c708268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c708268",
  null
  
)

export default component.exports